// Neutralize document-hijacking tags before email HTML is injected via
// dangerouslySetInnerHTML. The motivating bug (v1.3.50): NetSuite invoice emails carry
// `<base href="https://….netsuite.com/">`, and a <base> tag anywhere in the document
// rewrites how EVERY relative URL resolves — so after rendering one such email, all of
// the app's own `fetch("/api/…")` calls went to netsuite.com and died on CORS
// (attachments, notifications, SMS polling — everything until a page refresh).
// Regex-based so it stays testable in node (no DOMParser); this is scoped to
// document-level hijackers, not a full XSS sanitizer.
export function sanitizeEmailHtml(html: string): string {
  return html
    .replace(/<base\b[^>]*>/gi, "")
    .replace(/<script\b[^>]*>[\s\S]*?<\/script\s*>/gi, "")
    .replace(/<script\b[^>]*\/?>/gi, "")
    .replace(/<meta\b[^>]*http-equiv\s*=\s*["']?refresh["']?[^>]*>/gi, "");
}
